import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Mail, X } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';

const KEY = 'im_banner_dismissed';
const QUIET = /^\/((read|story|series|confessions|prazer|livros)\/[^/]+|mensagens|admin)/;

// Discreet top notice for unread internal messages; "Mais tarde" hides it for this browser session.
export function MessagesBanner() {
  const { user, im } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(KEY));

  useEffect(() => { setDismissed(sessionStorage.getItem(KEY)); }, [im.latest_at]);

  if (!user || !im.count || QUIET.test(pathname) || (dismissed && dismissed === String(im.latest_at))) return null;

  const later = () => {
    sessionStorage.setItem(KEY, String(im.latest_at));
    setDismissed(String(im.latest_at));
  };

  return (
    <div className="fixed top-14 md:top-16 inset-x-0 z-40 flex justify-center px-3 pointer-events-none" data-testid="messages-banner">
      <div className="pointer-events-auto mt-2 flex flex-wrap items-center gap-3 rounded-2xl sm:rounded-full border border-ruby/30 bg-surface/95 backdrop-blur px-3 sm:px-4 py-2 shadow-lg max-w-md sm:max-w-none">
        <Mail className="w-4 h-4 text-ruby shrink-0" />
        <span className="text-sm text-foreground" data-testid="messages-banner-text">
          {im.count === 1 ? 'Tens 1 mensagem nova da Intimate.pt.' : `Tens ${im.count} mensagens novas da Intimate.pt.`}
        </span>
        <Button size="sm" className="h-7 rounded-full bg-ruby hover:bg-ruby-light text-white" onClick={() => { later(); navigate('/mensagens'); }} data-testid="messages-banner-view">Ver mensagens</Button>
        <button className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1" onClick={later} data-testid="messages-banner-later">
          <X className="w-3 h-3" />Mais tarde
        </button>
      </div>
    </div>
  );
}
